import React from 'react';
import { MedicalHistoryConfig } from '../../../../../api/pushGenie';
import CommonItemsRender from './CommonItemsRender';
import { settingsIcon } from '../../../../common/Icons';
import { MEDICAL_HISTORY_CATEGORY, MHC, MHItem2 } from '../../../../../store/types/medicalHistory';

const CommonItemsMH: React.FC<{
    isMedicalHistorySection: boolean | undefined;
    medicalHistoryConfigData: MedicalHistoryConfig;
    onConfigure?: () => void;
    openHistoryConfigDialog?: () => void;
    onItemSave: (
        catId: MEDICAL_HISTORY_CATEGORY,
        item: MHItem2,
        index?: number | undefined,
    ) => void;
    onItemDelete: (catId: MEDICAL_HISTORY_CATEGORY, itemId: string) => void;
    patientHistoryData: MHC | undefined;
    StatusMessage: {
        [key: string]: string;
    };
    medicalHistoryOptions: any;
    className?: string;
    hideCommonItems?: boolean;
    showMHConfigure?: boolean;
}> = ({
    isMedicalHistorySection,
    medicalHistoryConfigData,
    onConfigure,
    openHistoryConfigDialog,
    onItemSave,
    onItemDelete,
    patientHistoryData,
    StatusMessage,
    medicalHistoryOptions,
    className,
    hideCommonItems = false,
    showMHConfigure = true,
}) => {
    return (
        <div
            className={`grid grid-cols-2 lg:grid-cols-3 gap-16
        ${isMedicalHistorySection ? '' : 'mt-8'} ${
                medicalHistoryConfigData?.commonItems?.length &&
                medicalHistoryConfigData?.sections?.length
                    ? className ?? ''
                    : ''
            }${
                isMedicalHistorySection && medicalHistoryConfigData?.commonItems?.length
                    ? 'pt-16'
                    : ''
            } w-full `}
        >
            {!hideCommonItems &&
                medicalHistoryConfigData?.commonItems?.map((data, i) => {
                    return (
                        <CommonItemsRender
                            key={data.id}
                            index={i}
                            medicalHistoryConfigCommonItemsData={data}
                            onItemSave={onItemSave}
                            onItemDelete={onItemDelete}
                            patientHistoryData={patientHistoryData}
                            isMedicalHistorySection={isMedicalHistorySection}
                            StatusMessage={StatusMessage}
                            medicalHistoryOptions={medicalHistoryOptions}
                        />
                    );
                })}
            {showMHConfigure && (
                <div
                    className={`flex cursor-pointer relative select-none items-center space-x-8 frequently-item-mh my-1 mr-20 group`}
                    onClick={onConfigure ? onConfigure : openHistoryConfigDialog}
                >
                    <div
                        className={`flex cursor-pointer items-center justify-center min-w-32 min-h-32 w-32 h-32 rounded-full border border-darwin-primary-500`}
                    >
                        {settingsIcon('w-16 h-16 fill-darwin-primary-500')}
                    </div>
                    <p className="text-darwin-primary-500">Configure</p>
                </div>
            )}
        </div>
    );
};

export default CommonItemsMH;
